
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * MarginRateProfilePositionMode enum
 */
class MarginRateProfilePositionMode {
  /**
   * Initialize enum with a given value
   * @param {MarginRateProfilePositionMode|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof MarginRateProfilePositionMode) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!MarginRateProfilePositionMode}
   * @param {!MarginRateProfilePositionMode} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof MarginRateProfilePositionMode)) {
      throw new TypeError('Instance of MarginRateProfilePositionMode is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!MarginRateProfilePositionMode}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!MarginRateProfilePositionMode}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === MarginRateProfilePositionMode.ALL_POSITIONS.value) {
      return 'ALL_POSITIONS'
    }
    if (this.value === MarginRateProfilePositionMode.NEW_POSITIONS.value) {
      return 'NEW_POSITIONS'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!MarginRateProfilePositionMode}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!MarginRateProfilePositionMode}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!MarginRateProfilePositionMode} Created enum
   */
  static fromObject (other) {
    return new MarginRateProfilePositionMode(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
MarginRateProfilePositionMode.ALL_POSITIONS = new MarginRateProfilePositionMode(0 + 0)
// noinspection PointlessArithmeticExpressionJS
MarginRateProfilePositionMode.NEW_POSITIONS = new MarginRateProfilePositionMode(0 + 1)

export { MarginRateProfilePositionMode };

/**
 * Fast Binary Encoding MarginRateProfilePositionMode field model
 */
class FieldModelMarginRateProfilePositionMode extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelMarginRateProfilePositionMode}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelMarginRateProfilePositionMode}
   * @param {MarginRateProfilePositionMode=} defaults Default value, defaults is new MarginRateProfilePositionMode()
   * @returns {!MarginRateProfilePositionMode} Result value
   */
  get (defaults = new MarginRateProfilePositionMode()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new MarginRateProfilePositionMode(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelMarginRateProfilePositionMode}
   * @param {!MarginRateProfilePositionMode} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelMarginRateProfilePositionMode };
